import { NUM_HABITATS, NUM_GLOBE_LOAD_FRAMES, TURTLE, BUTTERFLY } from 'helpers/constants';

export const cameraOptions = {
	fov: 45,
	near: 0.1,
	far: 100,
	xPos: 0,
	yPos: 0,
	zPos: 3.6,
};

export const globeOptions = {
	habitatZoomScale: 1.1,
	landingScale: 1,
	fullGlobeVisibleScale: 0.7,
	landingYPos: -1.4,
	landingRotationY: - Math.PI / 1.6,
	middleYPos: -0.07,
	habitatZoomYPos: -0.6,
	pledgeCardsYPos: 0.6,
	pledgeCardsScale: 1.1,
};

export const textTopOptions = {
	xPos: 0,
	yPos: 0.6,
	zPos: -2.67,
	hiddenXPos: -3.5,
	scale: 0.25
};

export const textBottomOptions = {
	xPos: 0,
	yPos: -0.65,
	zPos: -2.67,
	hiddenXPos: 3.5,
	scale: 0.25
};

export const getChildModel = (model, childName) => {
	let found;
	model.traverse((child) => {
		if (child.name === childName) {
			found = child;
		}
	});
	return found;
};

export const getLandingAssetsToLoad = () => {
	const assets = [
		'globe',
		'paper',
		'envMap',
		'textBottom',
		'textTop',
		'landingAudio'
	];
	const habitatTextures = Array(NUM_HABITATS).fill('textureHabitat').map((habitat, i) => {
		return `${habitat}${i + 1}`;
	});
	const globeLoader = Array(NUM_GLOBE_LOAD_FRAMES).fill('globe-load').map((globe, i) => (
		`${globe}-${i + 1}`
	));

	return [...assets, ...habitatTextures, ...globeLoader];
};

export const shouldDisableHabitat = ({ habitatNum, animal }) => {
	if (__IS_LOCAL__ || __IS_DEMO__) {
		return false;
	}
	let shouldDisable = false;
	if (habitatNum == 2 || animal === TURTLE) {
		// turtle habitat - 29 Oct 2023, 18:00 UTC
		shouldDisable = Date.now() < Date.UTC(2023, 9, 29, 18);
	}
	if (habitatNum == 3 || animal === BUTTERFLY) {
		// butterfly habitat - 5 Nov 2023, 18:00 UTC
		shouldDisable = Date.now() < Date.UTC(2023, 10, 5, 18);
	}
	return shouldDisable;
};